import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import { StoreProvider } from '../../components';

import FlashOfferCell from './FlashOfferCell';

export class FlashOffersList extends Component {
  render() {
    const { flashOffers: connection } = this.props.lists;
    const offers = connection.edges.map((e) => e.node);

    return (
      <div className="offers">
        <div className="header">
          <h2>Flash Offers</h2>
        </div>

        <table className="tables">
          <thead>
            <tr>
              <th>Brand</th>
              <th>Title</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            {offers.map((offer, index) => (
              <FlashOfferCell key={offer.id} offer={offer} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const FlashOffersContainer = createFragmentContainer(FlashOffersList, {
  lists: graphql`
    fragment FlashOffersList_lists on Lists {
      flashOffers(first: 50) {
        edges {
          node {
            id
            ...FlashOfferCell_offer
          }
        }
      }
    }
  `,
});

export default class FlashOffers extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={FlashOffersContainer}
        query={graphql`
          query FlashOffersListQuery {
            lists {
              ...FlashOffersList_lists
            }
          }
        `}
      />
    );
  }
}
